import { getDate } from './../utilities/date';
import { collection, doc, getDoc, getDocs } from "firebase/firestore"
import { firestore } from "../utilities/firebaseConfig"


export const findAll = async () => {
    const posts = await getDocs(collection(firestore, "posts"))
    let res: Array<any> = []
    posts.forEach(post => {
        const { title, body, description, image, timestamp } = post.data();
        res.push({ id: post.id, title, body, description, image, date: getDate(timestamp.toDate()) })
    })
    return res
}

export const findAPost = async (id: any) => {
    const postRef = doc(firestore, "posts", id);
    let res: any;
    try {
        const postSnap = await getDoc(postRef);
        if (postSnap.exists()) {
            res = {
                data: { ...postSnap.data(), date: getDate(postSnap.data().timestamp.toDate()) },
                success: true,
            };
        } else {
            res = {
                notExist: true,
            };
        }

    } catch (error) {
        res = {
            error: true,
        };
    }

    return res;
}